
const About = () => (
  <div style={{ padding: '2rem' }}>
    <h1>About Page</h1>
    <p>Welcome to the About page. This is a simple React component.</p>
  </div>
);

export default About;